module.exports = __webpack_public_path__ + "img/home_7.cb0fca80.jpg";